import type { TaxonomyContentEntry, TaxonomyEntry } from 'src/redux/content/types';

/** Merges fetched taxonomy content onto the matching entry by url, or appends if missing. */
export const mergeTaxonomyContentEntryIntoEntries = (
  entries: TaxonomyEntry[],
  fetchedEntry: TaxonomyContentEntry,
): TaxonomyEntry[] => {
  const content: TaxonomyEntry['content'] = {
    ...(fetchedEntry.heading ? { heading: fetchedEntry.heading } : {}),
    ...(fetchedEntry.subheading ? { subheading: fetchedEntry.subheading } : {}),
    ...(fetchedEntry.introCopy ? { introCopy: fetchedEntry.introCopy } : {}),
    ...(fetchedEntry.canonicalOverride
      ? { canonicalOverride: fetchedEntry.canonicalOverride }
      : {}),
  };
  const entryWithContent: TaxonomyEntry = {
    indexable: fetchedEntry.indexable,
    url: fetchedEntry.url,
    ...(content && Object.keys(content).length > 0 ? { content } : {}),
  };

  const matchIndex = entries.findIndex((entry) => entry.url === fetchedEntry.url);
  const next = [...entries];

  if (matchIndex >= 0) {
    next[matchIndex] = entryWithContent;
  } else {
    next.push(entryWithContent);
  }

  return next;
};
